import { useState, useEffect } from 'react';
import * as apiLogStore from '../../services/api/apiLogStore';

/**
 * Subscribe to the in-memory API log. Recording is manual (start/stop).
 * Max entries enforced by store to avoid slowness/crashes.
 */
export function useApiLog() {
  const [state, setState] = useState(() => apiLogStore.getState());

  useEffect(() => {
    const cb = (newState) => setState(newState);
    apiLogStore.subscribe(cb);
    return () => apiLogStore.unsubscribe(cb);
  }, []);

  return {
    entries: state.entries || [],
    isRecording: state.isRecording || false,
    startRecording: apiLogStore.startRecording,
    stopRecording: apiLogStore.stopRecording,
    clear: apiLogStore.clear,
    maxEntries: apiLogStore.MAX_ENTRIES,
  };
}
